<!--~
  ~ Copyright (c) 2010-2024 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<ng-container *ngIf='filterGroupEnabled'>
    <form [formGroup]='filterGroup' class='report-filter-container'>
        <mat-expansion-panel class='report-filters mat-elevation-z0'
                             [(expanded)]='filterPanelExpanded'
                             (afterExpand)='populateFilterDefaults()'>
            <mat-expansion-panel-header collapsedHeight='32px' expandedHeight='32px'>Filters
            </mat-expansion-panel-header>
            <div class="filter-controls-container">
                <div class="filter-row-container">

                    <div *ngFor='let filter of this.definition.filters; trackBy: filterTrackByFn'
                         class='filter-field-container f-column' [class.hide-filter]='filter.hidden'>

                        <div class="filter-field-name">{{getFilterFieldDisplayName(filter.field)}}:</div>

                        <ng-container [ngSwitch]='filter.type'>

                            <ng-container *ngSwitchCase="'string'">
                                <ng-container *ngTemplateOutlet="stringFilter; context: {filter, dataForm: filterGroup}"></ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="'string-exact'">
                                <ng-container *ngTemplateOutlet="stringFilter; context: {filter, dataForm: filterGroup}"></ng-container>
                            </ng-container>

                            <ng-container *ngSwitchCase="'number'">
                                <dash-gis-number-range formControlName='filter_{{filter.field}}'
                                                 [label]="getFilterFieldDisplayName(filter.field)"
                                                 [options]="filter.dropdownItems"
                                                 [class.hide-filter]='filter.hidden'></dash-gis-number-range>
                            </ng-container>

                            <div class='f-row f-no-shrink' *ngSwitchCase="'number_dropdown'">
                                <mat-form-field class='control-min' [class.hide-filter]='filter.hidden'>
                                    <mat-select formControlName='filter_{{filter.field}}_min'
                                                placeholder='Min'
                                                aria-label='{{getFilterFieldDisplayName(filter.field)}}'>
                                        <mat-option [value]='undefined'>-- Select --</mat-option>
                                        <mat-option *ngFor='let opt of filter.dropdownItems'
                                                    [value]='opt.value'>
                                            {{ opt.text }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class='control-max' [class.hide-filter]='filter.hidden'>
                                    <mat-select formControlName='filter_{{filter.field}}_max'
                                                placeholder='Max'
                                                aria-label='{{getFilterFieldDisplayName(filter.field)}}'>
                                        <mat-option [value]='undefined'>-- Select --</mat-option>
                                        <mat-option *ngFor='let opt of filter.dropdownItems'
                                                    [value]='opt.value'>
                                            {{ opt.text }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class='f-row f-no-shrink' *ngSwitchCase="'date'">
                                <dash-gis-date-range formControlName='filter_{{filter.field}}'
                                               [class.hide-filter]='filter.hidden'
                                               [options]='filter.dropdownItems'></dash-gis-date-range>
                            </div>

                        </ng-container>
                    </div>
                </div>
                <div class="filter-clear-container">
                    <button mat-button (click)="clearFilters()">Clear Filters</button>
                </div>
            </div>
        </mat-expansion-panel>
    </form>
</ng-container>

<ng-template #stringFilter let-filter="filter" let-form="dataForm">
    <ng-container [formGroup]="form">
        <ng-container *ngIf="shouldDisplaySelect(filter)">
            <ng-container *ngIf="getDropdownOptions$(filter) | async; let options">
                <mat-form-field>
                    <mat-select formControlName='filter_{{filter.field}}'
                                [multiple]="filter.multi ?? false"
                                aria-label='{{getFilterFieldDisplayName(filter.field)}}'>
                        <mat-option *ngIf="!filter.multi" [value]='undefined'>-- Select --</mat-option>
                        <mat-option *ngFor='let opt of options'
                                    [value]='opt.value'>
                            {{ opt.text }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="!shouldDisplaySelect(filter)">
            <mat-form-field class='control-span' [class.hide-filter]='filter.hidden'>
                <input matNativeControl cdkMonitorElementFocus
                       name='filter_{{filter.field}}' type='text'
                       formControlName='filter_{{filter.field}}' />
            </mat-form-field>
        </ng-container>
    </ng-container>
</ng-template>